export default __webpack_public_path__ + "static/media/Koushik.6d13c4b8.png";